export const SMALL_SCREEN_QUERY = "(max-width: 1400px)";
export const NEW_HIGHLIGHT_HOURS = 24;
